import React, { useContext, useEffect, useRef } from "react"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ChartData
} from "chart.js"
import { Bar } from "react-chartjs-2"
import { _DeepPartialObject } from "chart.js/dist/types/utils"
import { ChartJSOrUndefined } from "react-chartjs-2/dist/types"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"

Filler.beforeDraw = function (c, a, b) {
    var ctx = c.ctx
    ctx.fillStyle = "white"
    ctx.fillRect(0, 0, c.width, c.height)
    return true
}

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Filler
)

interface BarChartProps {
    data: any
    title: string
    anno: number
    dataKey: string
}

export default function ChartRegionaliMultiAnno({
    data,
    title,
    anno,
    dataKey
}: BarChartProps) {
    var distinctArr: { values: number[]; label: string }[] = []

    data.map((e: any) => ({
        label: e.regione,
        values: data
            .filter(
                (f: { regione: any }) =>
                    f.regione.replace("-", " ").split("/")[0] ==
                    e.regione.replace("-", " ").split("/")[0]
            )
            .map((m: any) =>
                Number(m[dataKey].replaceAll(".", "").replaceAll(",", "."))
            )
    })).filter(function (item: typeof distinctArr[0]) {
        let i = distinctArr.findIndex(
            (x: { label: any }) =>
                x.label.replace("-", " ").split("/")[0] ==
                item.label.replace("-", " ").split("/")[0]
        )
        if (i <= -1 && item.label !== "Totale") {
            distinctArr.push(item)
        }
        return null
    })

    let ordinati = distinctArr.slice().sort((a, b) => {
        return a.label.localeCompare(b.label, "it", {
            sensitivity: "base"
        })
    })

    let itemToRemove = ordinati.find((e) => e.label === "Totale")
    if (itemToRemove != undefined) {
        ordinati = ordinati.filter((a) => a != itemToRemove)
        ordinati.push(itemToRemove)
    }

    const options = {
        indexAxis: "y" as const,
        //fullWidth:true,
        mantainAspectRatio: false,
        aspectRatio: 1,
        elements: {
            bar: {
                borderWidth: 1,
                padding: 10
            }
        },
        scales: {
            y: {
                ticks: {
                    font: { size: 14 }
                }
            },
            x: {
                ticks: {
                    stepSize: Math.max(data.map((e: any) => e[dataKey])) / 14
                },
                suggestedMax:
                    dataKey == "punteggioIsaAnom" ||
                    dataKey == "punteggioIsaNonAnom"
                        ? 10
                        : undefined
            }
        },
        responsive: false,
        interaction: {
            mode: "index" as const,
            axis: "y" as const,
            intersect: false
        },
        //grouped: true,
        plugins: {
            legend: {
                position: "right" as const
            },
            title: {
                display: true,
                text: title,
                font: { size: 18 }
            }
        }
    }
    const datasets = {
        labels: ordinati.map(({ label }) => label),

        datasets: [
            {
                label: anno.toString(),
                data: ordinati.map(({ values }) => values[0]),
                backgroundColor: "#00008B",
                barThickness: 8,

                borderRadius: 15
            },
            {
                label: (anno + 1).toString(),
                data: ordinati.map(({ values }) => values[1]),
                backgroundColor: "#008000",
                barThickness: 8,

                borderRadius: 15
            },
            {
                label: (anno + 2).toString(),
                data: ordinati.map(({ values }) => values[2]),
                backgroundColor: "#FF0000",
                barThickness: 8,

                borderRadius: 15
            }
        ]
    }
    const chartRef = useRef<ChartJSOrUndefined<"bar", number[], string>>(null)
    const [_, dispatch] = useContext(MultiAnnoContext)
    useEffect(() => {
        dispatch({
            type: "setChartRef",
            value: {
                chartRef: chartRef.current as ChartJSOrUndefined<
                    "bar",
                    number[],
                    string
                >
            }
        })
    }, [chartRef.current])

    return (
        <div style={{ width: 1000, height: 1000 }}>
            <Bar
                ref={chartRef}
                className="barChart_ChartJs"
                options={options}
                data={datasets}
                width={1000}
                height={1000}
            />
        </div>
    )
}
